export const getIsIframe: () => boolean | undefined = () => {
	try {
		return typeof window !== 'undefined' && window.self !== window.top;
	} catch (e) {
		// Accessing window.top can throw a SecurityError in cross‑origin cases
		return true; // If we can't access top, we *are* in an iframe
	}
};
